module.exports = __webpack_public_path__ + "img/fork-of-dash-1.58f26603.png";